import MyExecutionMilestonesPage from "../../shared/project-execution-plan/MyExecutionMilestonesPage";

const SupplierExecutionMilestonesPage = () => (
  <MyExecutionMilestonesPage role="Supplier" />
);

export default SupplierExecutionMilestonesPage;
